import { SpinnerContainer } from "./style";
const Spinner = () => {
return(
    <SpinnerContainer>
        <div className="sm-primary-loader"></div>
    </SpinnerContainer>
)
}

export default Spinner;